// extracted by mini-css-extract-plugin
module.exports = {"containerEmpty":"BooksetListEmpty__containerEmpty","titleEmpty":"BooksetListEmpty__titleEmpty"};